import {useEffect, useState} from 'react';

import {useSharedConfig} from '@src/Components/SharedConfigProvider';

import * as classes from './Admin.module.scss';

function Admin() {
	const {sharedConfig, updateSharedConfig} = useSharedConfig();

	const [prize1Probability, setPrize1Probability] = useState(
		sharedConfig.prize1Probability
	);
	const [prize2Probability, setPrize2Probability] = useState(
		sharedConfig.prize2Probability
	);
	const [prize3Probability, setPrize3Probability] = useState(
		sharedConfig.prize3Probability
	);
	const [noPrizeProbability, setNoPrizeProbability] = useState(
		sharedConfig.noPrizeProbability
	);

	useEffect(() => {
		setPrize1Probability(sharedConfig.prize1Probability);
		setPrize2Probability(sharedConfig.prize2Probability);
		setPrize3Probability(sharedConfig.prize3Probability);
		setNoPrizeProbability(sharedConfig.noPrizeProbability);
	}, [sharedConfig]);

	return (
		<div className={classes.adminContainer}>
			<h1>Einstellungen</h1>
			<div className={classes.inputGroup}>
				<label htmlFor='prize1Probability'>
					Wahrscheinlichkeit Hauptpreis
				</label>
				<input
					type='number'
					id='prize1Probability'
					value={prize1Probability}
					onChange={(e) => {
						setPrize1Probability(Number(e.target.value));
					}}
				/>
			</div>
			<div className={classes.inputGroup}>
				<label htmlFor='prize2Probability'>
					Wahrscheinlichkeit Preiskategorie 2
				</label>
				<input
					type='number'
					id='prize2Probability'
					value={prize2Probability}
					onChange={(e) => {
						setPrize2Probability(Number(e.target.value));
					}}
				/>
			</div>
			<div className={classes.inputGroup}>
				<label htmlFor='prize3Probability'>
					Wahrscheinlichkeit Preiskategorie 3
				</label>
				<input
					type='number'
					id='prize3Probability'
					value={prize3Probability}
					onChange={(e) => {
						setPrize3Probability(Number(e.target.value));
					}}
				/>
			</div>
			<div className={classes.inputGroup}>
				<label htmlFor='noPrizeProbability'>
					Wahrscheinlichkeit Kein Preis
				</label>
				<input
					type='number'
					id='noPrizeProbability'
					value={noPrizeProbability}
					onChange={(e) => {
						setNoPrizeProbability(Number(e.target.value));
					}}
				/>
			</div>

			<button
				onClick={() => {
					updateSharedConfig({
						prize1Probability,
						prize2Probability,
						prize3Probability,
						noPrizeProbability,
					});
				}}
			>
				Einstellungen speichern
			</button>
		</div>
	);
}

export default Admin;
